<template>
  <modal @close="modals.omsEnquiryModal = false">
      <h3 v-if="job">Reorder On Bookblock</h3>
      <h3 v-else>Make New Bookblock Enquiry</h3>
      <div class="large-form">
          <div class="form-line">
              <div class="form-field" v-if="!job">
                  <div class="small-note" style="margin-bottom: 20px" >
                      <b>Easily make a new enquiry for any personalised product from our range.</b> Please specify the product type, quantity, customisation requirements and any additional details in the form below.
                      <br /><br />
                      You can view our full product range, including pricing estimates, minimum order quantities and estimated turnaround time on <a href="https://business.bookblock.com/" target="_blank">business.bookblock.com</a>.
                  </div>
                  <label>Enquiry Subject</label>
                  <input type="text" v-model="item.name" required placeholder="What type of product are you interested in?" />
              </div>
              <div class="form-field">
                  <div class="small-note" style="margin-bottom: 20px" v-if="job">
                      <b>Are you interested in reordering?</b> We're happy to help! Please specify required quantity and provide details on any changes to the original job that you require.
                  </div>
                  <label>Item Quantity</label>
                  <input type="number" v-model="item.quantity" required />
              </div>
              <div class="form-field" >
                  <label>Enquiry Details</label>
                  <textarea v-model="item.details.message" rows="5" :placeholder="placeholderText"></textarea>
              </div>
          </div>
          <div class="modal-errors">
              <p v-for="e in errors" class="form-field error-text">{{ e[0] }}</p>
          </div>
      </div>
      <div class="form-actions">
          <span class="ws-button ws-button-main" @click="sendEnquiry">SEND ENQUIRY</span>
          <span class="ws-button ws-button-secondary" data-action="cancel" @click="modals.omsEnquiryModal = false">GO BACK</span>
      </div>
  </modal>
</template>


<script>
import Modal from "@/components/modals/Modal";

export default {
    name: "NewEnquiryModal",
    components: {Modal},
    props: {job: null},
    data() {
        return {
            item: {
                job_id: null,
                name: '', 
                quantity: 100,
                details: {
                    message: '',
                },
                source: 'new-order',
            },
            errors: {},
        }
    },
    methods: {
      async sendEnquiry() {
          this.errors = this.validateFields([
              { name: 'Enquiry Subject', value: this.item.name, rules: ['required', 'minLength:3'] },
              { name: 'Quantity', value: this.item.quantity, rules: ['required'] },
              { name: 'Enquiry Details', value: this.item.details.message, rules: ['required'] },
          ]);
          if (Object.keys(this.errors).length) return;
          if (this.item.job_id) this.item.details.original_job_id = this.item.job_id;
          
          let result = await this.dispatchWaitAndNotify('sendOMSEnquiry', this.item);
          if (result?.response?.data?.id) {
              this.modals.omsEnquiryModal = false;
              this.$router.push('/orders/' + result.response.data.id);
          }
      }
    },
    async mounted() {
        if (this.job) {
            this.item.job_id = this.job.id;
            this.item.name = 'Reorder: ' + this.job.name;
            this.item.quantity = this.job.quantity;
            this.item.source = 're-order';
        }
    },
    computed: {
        modals() {
            return this.$store.state.modals;
        },
        placeholderText() {
            return this.job?
                'Please specify in detail any changes to the previous job that you require.':
                'Please let us know what type of product or service you are interested in, and provide any further details.';
        }
    }
}
</script>

<style scoped>

</style>